import React, { FunctionComponent } from "react";

import { FilterBar, useTheme } from "@bps/fluent-ui";
import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { TenantFilterValues } from "./tenants-filter.types";
import { getTenantsFilterStrippedValues } from "./tenants-filter.utils";
import { useTenantsFilterSearchParams } from "./use-tenants-filter-search-params.hook";

export const TenantsFilter: FunctionComponent = () => {
  const theme = useTheme();
  const { initialValues, setSearchParams } = useTenantsFilterSearchParams();
  return (
    <FilterBar<TenantFilterValues>
      maxItemWidth={200}
      initialValues={initialValues}
      items={[
        {
          type: "searchBox",
          name: "name",
          props: {
            styles: { root: { minWidth: 220 } },
            placeholder: "Search tenants by Name",
            removeSpecialCharacters: false
          },
          stickItem: true
        },
        {
          type: "searchBox",
          name: "tenantId",
          props: {
            styles: { root: { minWidth: 300 } },
            placeholder: "Search tenants by Id",
            removeSpecialCharacters: false
          },
          stickItem: true
        },
        {
          type: "searchBox",
          name: "selfAssertedCrmId",
          props: {
            styles: { root: { minWidth: 220 } },
            placeholder: "Search by Self-Asserted CrmId",
            removeSpecialCharacters: false
          },
          stickItem: true
        },
        {
          type: "searchBox",
          name: "crmId",
          props: {
            styles: { root: { minWidth: 220 } },
            placeholder: "Search tenants by CrmId",
            removeSpecialCharacters: false
          },
          stickItem: true
        },
        {
          type: "optionsSelect",
          name: "applications",
          props: {
            placeholder: "Application",
            hideSearchOption: true,
            multiSelect: true,
            options: [
              { key: ApplicationType.OMNI, text: "Omni" },
              { key: ApplicationType.PROS, text: "Pros" },
              { key: ApplicationType.CAM, text: "Cam" }
            ]
          }
        }
      ]}
      onChange={({ state: { values } }) => {
        const strippedValues = getTenantsFilterStrippedValues(values);
        setSearchParams(strippedValues as any);
      }}
      presets={[
        {
          name: "isInactive",
          iconName: "BlockContact",
          iconColor: theme.semanticColors.errorIcon,
          text: "Show inactive",
          textPressed: "Show active"
        }
      ]}
    />
  );
};
